import { render, staticRenderFns } from "./teacherModule.vue?vue&type=template&id=3e77281e"
import script from "./teacherModule.vue?vue&type=script&lang=js"
export * from "./teacherModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports